<!-- WEB DRAWING ANALYSIS TOOLS -->
<div class="drawing-mode-selector-container">
  <ng-container *ngIf="availableViewerModes">
    <mat-tab-group
      class="auto-size no-inkbar"
      (selectedTabChange)="toggleViewerMode.emit(availableViewerModes[$event.index])"
      [animationDuration]="0"
      [disableRipple]="true"
      [selectedIndex]="selectedToolIndex"
    >
      <mat-tab *ngFor="let tool of availableViewerModes">
        <ng-template matTabLabel>
          <i
            [matTooltip]="'tooltip.activate_' + tool + '_mode' | translate"
            [matTooltipShowDelay]="1000"
            #toolTooltip="matTooltip"
            (mouseleave)="toolTooltip.hide()"
            [attr.data-cy]="'tool-' + tool"
            [attr.active]="tool === activeViewerMode"
            [class.text-primary]="tool === activeViewerMode"
            [class.ri-drag-move-2-line]="tool === ViewerMode.idle"
            [class.ri-pencil-line]="tool === ViewerMode.drawing || tool === ViewerMode.free"
            [class.ri-cursor-line]="tool === ViewerMode.selecting"
            (click)="toggleViewerMode.emit(tool)"
          ></i>
        </ng-template>
        <ng-template matTabContent>
          <ng-container [ngSwitch]="activeViewerMode">
            <div *ngSwitchCase="ViewerMode.drawing" class="flex-row justify-content-around">
              <button
                *ngFor="let availableMode of availableDrawingModes"
                class="btn btn-auto flex-row align-items-center"
                [class.btn-flat-gray]="activeDrawingMode !== availableMode"
                [class.btn-flat-primary]="activeDrawingMode === availableMode"
                (click)="toggleDrawingMode.emit(availableMode)"
                [attr.data-cy]="'button-drawing-' + availableMode"
              >
                <i
                  [class.ri-focus-3-line]="availableMode === DrawingMode.center"
                  [class.ri-shape-line]="availableMode === DrawingMode.boundingBox"
                ></i>
                {{ (availableMode === DrawingMode.center ? 'core.point' : 'core.region') | translate | uppercase }}
              </button>
            </div>
            <div *ngSwitchCase="ViewerMode.selecting" class="flex-row justify-content-around">
              <ng-container *ngIf="selectedROIs.size">
                <button
                  class="btn btn-danger toolbar-action flex-row align-items-center justify-content-center"
                  (click)="removeSelectedROIs.emit()"
                  [matTooltip]="'tooltip.remove_roi' | translate"
                  [matTooltipShowDelay]="1000"
                  #removeTooltip="matTooltip"
                  (mouseleave)="removeTooltip.hide()"
                  data-cy="button-remove-selected-rois"
                >
                  <i class="ri-delete-bin-6-line"></i>
                  {{ 'core.delete' | translate | uppercase }}
                  <span data-cy="selected-rois-count" style="margin-left: 5px">({{ selectedROIs.size }})</span>
                </button>
              </ng-container>
            </div>
            <div *ngSwitchCase="'free'" class="flex-row justify-content-around">
              <button
                *ngFor="let availableMode of availableDrawingModes"
                class="btn btn-auto flex-row align-items-center"
                [class.btn-flat-gray]="activeDrawingMode !== availableMode"
                [class.btn-flat-primary]="activeDrawingMode === availableMode"
                (click)="toggleDrawingMode.emit(availableMode)"
                [attr.data-cy]="'button-drawing-' + availableMode"
              >
                <i
                  [class.ri-brush-line]="availableMode === DrawingMode.sketch"
                  [class.ri-brush-fill]="availableMode === DrawingMode.lasso"
                ></i>
                <!-- {{ (availableMode.mode === "center" ? "core.point" : "core.region" ) | translate | uppercase }} -->
              </button>
            </div>
          </ng-container>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
